/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { PluginsPage } from '@/pages/Plugins/PluginsPage';

export function PluginsRoute() {
  return <PluginsPage />;
}
